
export const availableMoveSizeDetails = [
    {"id": "", "value": "4+ Bedroom Home", "icon": "icon-bedroom-5.svg"},
    {"id": "", "value": "3 Bedroom Home", "icon": "icon-bedroom-3.svg"},
    {"id": "", "value": "2 Bedroom Home", "icon": "icon-bedroom-2.svg"},
    {"id": "", "value": "Few Items", "icon": "fewitem.png"}
  ];